import * as types from "./ActionTypes";
import { AUTH_LOGOUT } from "Store/UserInfo/ActionTypes";
import InitialState from "Store/InitialState";

export default function userCourseRoleReducer(
  state = InitialState.userCourseRole,
  action
) {
  switch (action.type) {
    case types.SET_USER_COURSE_ROLE:
      return action.payload;

    case AUTH_LOGOUT:
      return InitialState.userCourseRole;

    default:
      return state;
  }
}

// Separate reducer for course approval status (keyed by courseId)
export function courseApprovalStatusReducer(
  state = {},
  action
) {
  switch (action.type) {
    case types.SET_COURSE_APPROVAL_STATUS:
      return {
        ...state,
        [action.payload.courseId]: action.payload.status,
      };

    default:
      return state;
  }
}
